<template>
  <div class="h5-iso-painter">
    <canvas id="isoPainter" :width="canvasData.side" :height="canvasData.side" style="border:1px solid #d3d3d3;">
      您的浏览器不支持 HTML5 canvas 标签。
    </canvas>
    <div>
      <el-button type="primary" @click="doCreateIsogram(isoData)" style="width:100px;height:36px;">生成</el-button>
      <el-button type="primary" @click="clearCanvas()" style="width:100px;height:36px;">清空</el-button>
    </div>
  </div>
</template>

<script>
// import api from '../../api/index'
export default {
  data () {
    return {
      canvasData: {
        // width: 800,
        // height: 800,
        // sideMax: 0 // 算
        side: 800
      },
      isoData: {
        // grid: {
        //   minX: -200, // 填
        //   minY: -100, // 填
        //   maxX: 600, // 填
        //   maxY: 300, // 填
        //   setpX: 100, // 填
        //   setpY: 100, // 填
        //   numX: 0, // 算
        //   numY: 0, // 算
        //   numMax: 0, // 算
        //   // range: 0, // 算
        //   scaleSqr: 0, // 算
        //   marginX: 0, // 算
        //   marginY: 0, // 算
        //   square: [
        //     [0, 1, 2, 3, 4, 5, 4, 3, 2],
        //     [10, 11, 12, 13, 14, 15, 14, 13, 12],
        //     [10, 11, 12, 13, 14, 15, 14, 13, 12],
        //     [10, 11, 12, 13, 14, 16, 14, 13, 12],
        //     [1, 2, 3, 4, 5, 4, 3, 2, 1]
        //   ]
        // },
        // grid: {
        //   minX: -200, // 填
        //   minY: -100, // 填
        //   maxX: 400, // 填
        //   maxY: 300, // 填
        //   setpX: 100, // 填
        //   setpY: 100, // 填
        //   numX: 0, // 算
        //   numY: 0, // 算
        //   numMax: 0, // 算
        //   // range: 0, // 算
        //   scaleSqr: 0, // 算
        //   marginX: 0, // 算
        //   marginY: 0, // 算
        //   square: [
        //     [0, 1, 2, 3, 4, 5, 6],
        //     [5, 6, 7, 8, 10, 12, 13],
        //     [10, 11, 12, 13, 14, 15, 14],
        //     [8, 9, 10, 11, 12, 13, 13],
        //     [1, 2, 3, 4, 5, 4, 8]
        //   ]
        // },
        grid: {
          minX: 0, // 填
          minY: 0, // 填
          maxX: 1400, // 填
          maxY: 1400, // 填
          setpX: 100, // 填
          setpY: 100, // 填
          numX: 0, // 算
          numY: 0, // 算
          numMax: 0, // 算
          // range: 0, // 算
          scaleSqr: 0, // 算
          marginX: 0, // 算
          marginY: 0, // 算
          square: [
            [3.51, 3.51, 3.51, 3.51, 3.51, 3.50, 3.50, 3.49, 3.49, 3.46, 3.44, 3.27, 3.03, 2.77, 2.52],
            [4.33, 4.33, 4.33, 4.33, 4.32, 4.32, 4.30, 4.30, 4.29, 4.23, 4.21, 3.90, 3.51, 3.13, 2.78],
            [5.64, 5.64, 5.64, 5.64, 5.63, 5.61, 5.58, 5.57, 5.56, 5.43, 5.37, 4.77, 4.11, 3.53, 3.05],
            [8.03, 8.03, 8.02, 8.01, 7.99, 7.94, 7.86, 7.82, 7.79, 7.45, 7.30, 5.97, 4.80, 3.93, 3.30],
            [13.30, 13.30, 13.28, 13.25, 13.13, 12.92, 12.58, 12.40, 12.30, 11.03, 10.58, 7.39, 5.46, 4.27, 3.50],
            [14.32, 14.32, 14.31, 14.26, 14.11, 13.84, 13.43, 13.20, 13.09, 11.58, 11.06, 7.55, 5.52, 4.31, 3.51],
            [18.35, 18.35, 18.31, 18.19, 17.79, 17.16, 16.28, 15.85, 15.64, 13.19, 12.43, 7.95, 5.68, 4.38, 3.56],
            [18.85, 18.85, 18.80, 18.67, 18.21, 17.50, 16.55, 16.09, 15.87, 13.32, 12.53, 7.98, 5.69, 4.38, 3.56],
            [20.04, 20.04, 19.97, 19.78, 19.15, 18.23, 17.10, 16.58, 16.32, 13.57, 12.74, 8.03, 5.71, 4.39, 3.56],
            [24.54, 24.53, 24.32, 23.74, 22.02, 20.12, 18.31, 17.61, 17.28, 14.06, 13.14, 8.14, 5.75, 4.41, 3.57],
            [34.93, 34.88, 33.97, 31.61, 26.21, 22.11, 19.31, 18.40, 18.00, 14.39, 13.41, 8.21, 5.77, 4.42, 3.58],
            [69.06, 68.71, 61.77, 48.82, 31.69, 23.92, 20.05, 18.96, 18.49, 14.61, 13.59, 8.25, 5.79, 4.43, 3.58],
            [131.10, 128.99, 96.57, 61.80, 34.09, 24.55, 20.29, 19.15, 18.66, 14.69, 13.66, 8.27, 5.80, 4.44, 3.59],
            [275.82, 257.62, 129.00, 68.76, 35.04, 24.81, 20.41, 19.25, 18.75, 14.74, 13.70, 8.28, 5.80, 4.44, 3.59],
            [299.71, 275.82, 131.12, 69.11, 35.10, 24.84, 20.43, 19.26, 18.77, 14.75, 13.71, 8.29, 5.80, 4.44, 3.59]
          ]
        },
        isoLines: {
          minIso: 0, // 填
          maxIso: 300, // 填
          stepIso: 10, // 填
          listIso: [0, 3, 6, 9, 12, 15] // 算
        }
      }
    }
  },
  created () {
  },
  mounted () {
    // 预处理canvas数据
    // this.canvasData.sideMax = this.canvasData.width > this.canvasData.height ? this.canvasData.width : this.canvasData.height
  },
  methods: {
    doCreateIsogram (isoData) {
      var c = document.getElementById('isoPainter')
      var ctx = c.getContext('2d')
      const MarchingSquaresJS = require('marchingsquares')
      var cvsSide = this.canvasData.side
      var dataGrid = isoData.grid
      var dataSquare = isoData.grid.square
      var dIsoLines = isoData.isoLines
      // 预处理等值线属性数据
      dIsoLines.listIso = []
      for (var ilValue = dIsoLines.maxIso; ilValue >= dIsoLines.minIso; ilValue -= dIsoLines.stepIso) {
        dIsoLines.listIso.unshift(ilValue)
      }
      if (dataSquare[0][0] !== undefined && dIsoLines.listIso.length) {
        // 预处理grid数据 <= 待添加，先用死数据
        dataGrid.numX = (dataGrid.maxX - dataGrid.minX) / dataGrid.setpX + 1
        dataGrid.numY = (dataGrid.maxY - dataGrid.minY) / dataGrid.setpY + 1
        dataGrid.numMax = dataGrid.numX > dataGrid.numY ? dataGrid.numX : dataGrid.numY
        // dataGrid.range = dataGrid.maxX - dataGrid.minX > dataGrid.maxY - dataGrid.minY ? dataGrid.maxX - dataGrid.minX : dataGrid.maxY - dataGrid.minY
        dataGrid.scaleSqr = cvsSide / (dataGrid.numMax - 1 + 2) // 预留两侧各1单位空白
        dataGrid.marginX = dataGrid.scaleSqr * (1 + (dataGrid.numMax - dataGrid.numX) / 2)
        dataGrid.marginY = dataGrid.scaleSqr * (1 + (dataGrid.numMax - dataGrid.numY) / 2)
        console.log('dataGrid', dataGrid)
        // 绘制框线
        ctx.rect(
          dataGrid.marginX,
          dataGrid.marginY,
          dataGrid.scaleSqr * (dataGrid.numX - 1),
          dataGrid.scaleSqr * (dataGrid.numY - 1)
        )
        ctx.stroke()
        // 绘制坐标轴
        // ctx.beginPath()
        // ctx.lineWidth = '2'
        // ctx.moveTo(0, 75)
        // ctx.lineTo(cvsSide, 75)
        // ctx.stroke()
        // 网格数据预处理
        var prepData = new MarchingSquaresJS.QuadTree(dataSquare)
        console.log('prepData', prepData)
        var isoLvLineArr = []
        // 循环计算等值线
        dIsoLines.listIso.forEach(threshold => {
          var lineResult = MarchingSquaresJS.isoLines(prepData, threshold, { noFrame: false })
          isoLvLineArr.push({ lv: threshold, il: lineResult })
        })
        console.log('isoLvLineArr', isoLvLineArr)
        // 循环绘制等值线
        isoLvLineArr.forEach(ilvlItem => {
          if (ilvlItem.il.length) {
            ilvlItem.il.forEach(ilItem => {
              ctx.beginPath()
              ctx.lineWidth = '1'
              ctx.moveTo(dataGrid.marginX + dataGrid.scaleSqr * ilItem[0][0], dataGrid.marginY + dataGrid.scaleSqr * ilItem[0][1])
              for (var iIlp = 1; iIlp < ilItem.length; iIlp++) {
                ctx.lineTo(dataGrid.marginX + dataGrid.scaleSqr * ilItem[iIlp][0], dataGrid.marginY + dataGrid.scaleSqr * ilItem[iIlp][1])
              }
              ctx.stroke()
            })
          }
        })
      } else {
        this.$toast.text('网格数据格式错误！')
      }
    },
    clearCanvas () {
      var c = document.getElementById('isoPainter')
      var ctx = c.getContext('2d')
      // ctx.fillStyle = '#ffffff'
      ctx.clearRect(
        0,
        0,
        this.canvasData.side,
        this.canvasData.side
      )
    }
  }
}
</script>

<style lang="scss">
.h5-iso-painter {
  width: calc(100vw - 40px);
  height: calc(100vh - 40px);
  text-align: center;
  font-size: 20px;
  padding: 20px;
  word-break: break-word;
  white-space: pre-line;
}
</style>
